export const selectIsOpenDepositChannelBox = (state) => state.deposit.isOpenDepositChannelBox
